import { Link } from 'react-router-dom';
import { GameLayout } from './GameLayout';

export function AliasLanding() {
  return (
    <GameLayout>
      <AliasLandingStyles />
      <span className="al-land-label">/ Alias · командная игра на объяснение слов</span>
      <h1 className="al-land-title">Объясняй быстро.<br />Не называй <span>слово.</span></h1>
      <p className="al-land-lede">Соберите команды, отсканируйте QR-код и передайте ход объясняющему. Слово видно только ему, а сервер сам ведёт время, счёт и очередь игроков.</p>
      <div className="al-land-actions"><Link className="btn-primary lg" to="/play/alias/create">Создать комнату →</Link><Link className="btn-ghost lg" to="/rooms">Войти по коду</Link></div>
      <section className="al-land-grid">
        <Feature n="01" title="Один телефон — одно слово" text="Текущая карточка приходит только объясняющему. Общий экран и соперники видят таймер и счёт без спойлеров." />
        <Feature n="02" title="Команды по кругу" text="Система помнит составы, меняет объясняющего после каждого хода и завершает матч честно — после полного раунда." />
        <Feature n="03" title="Серверный таймер" text="Угаданные и пропущенные слова принимаются только до серверного дедлайна. Двойной тап не добавит очки дважды." />
        <Feature n="04" title="Без регистрации" text="Ведущий заранее вносит список. Игрок выбирает своё имя, получает сессию для возврата и может играть с телефона." />
      </section>
      <section className="al-land-rules">
        <span className="label">/ Как проходит игра</span>
        <ol>
          <li>Ведущий вводит игроков, отмечает себя и распределяет всех по двум или более командам.</li>
          <li>Каждый открывает ссылку или QR-код, выбирает своё имя и подтверждает готовность.</li>
          <li>Объясняющий запускает ход, получает слово и отмечает «Угадано» или «Пропустить».</li>
          <li>После таймера ведущий подтверждает результат, а система передаёт ход следующей команде.</li>
        </ol>
      </section>
    </GameLayout>
  );
}

function Feature({ n, title, text }: { n: string; title: string; text: string }) {
  return <article className="al-land-feature"><span>{n}</span><h3>{title}</h3><p>{text}</p></article>;
}

function AliasLandingStyles() {
  return <style>{`
    .al-land-label { font: 11px 'JetBrains Mono', monospace; color: var(--ink-faint); letter-spacing: .16em; text-transform: uppercase; }
    .al-land-title { margin: 14px 0 0; font: 600 clamp(58px, 9vw, 112px)/.91 'Oswald', sans-serif; letter-spacing: -.04em; }
    .al-land-title span { color: #ff6f43; font-family: 'Playfair Display', serif; font-style: italic; letter-spacing: -.07em; }
    .al-land-lede { max-width: 735px; margin: 26px 0 36px; color: var(--ink-dim); font-size: 18px; line-height: 1.55; }
    .al-land-actions { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 62px; }
    .al-land-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 13px; }
    .al-land-feature { min-height: 228px; padding: 22px; background: var(--bg2); border: 1px solid var(--line); border-radius: 12px; }
    .al-land-feature > span { color: #ff6f43; font: 11px 'JetBrains Mono', monospace; letter-spacing: .15em; }
    .al-land-feature h3 { margin: 15px 0 8px; font: 500 29px 'Oswald', sans-serif; }
    .al-land-feature p { margin: 0; color: var(--ink-dim); font-size: 13px; line-height: 1.5; }
    .al-land-rules { max-width: 800px; margin-top: 64px; padding-top: 24px; border-top: 1px solid var(--line); }
    .al-land-rules ol { color: var(--ink-dim); line-height: 1.65; padding-left: 22px; }
    .al-land-rules li { padding-left: 5px; margin-bottom: 9px; }
    @media (max-width: 900px) { .al-land-grid { grid-template-columns: 1fr 1fr; } }
    @media (max-width: 560px) { .al-land-grid { grid-template-columns: 1fr; } .al-land-lede { font-size: 16px; } }
  `}</style>;
}
